(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["LIFE_CYCLE_EVENT_BUS"] = factory();
	else
		root["LIFE_CYCLE_EVENT_BUS"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 